import { createRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { rootRoute } from '@/routes/root'

const verifyEmailRouteSchema = z.object({
  digest: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
})

export const verifyEmailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/verify-email',
  validateSearch: verifyEmailRouteSchema,
}).lazy(() => import('./verifyEmail').then((d) => d.Route))

export type VerifyEmailRouteSearchParams = z.infer<typeof verifyEmailRouteSchema>
